const FilecoinCnt = {
  symbol: "FIL",
  name: "Filecoin",
  meta: {
    title: "Buy Filecoin | Sell Filecoin | Filecoin prices and charts",
    description:
      "File Coin (FIL) has brought cloud storage technology to the world of digital currencies. Kevin Nick Market Direct and indirect sales of cryptocurrencies have provided the new technology of digital currencies.",
    keywords: "Filecoin, buy Filecoin, sell Filecoin, Filecoin price",
  },
  scripts: {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "چگونه فایل کوین بخریم؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "در پلتفرم معاملاتی کوین‌نیک مارکت می‌توانید با کارت بانکی عضو شتاب و کمترین کارمزد، اقدام به خرید فایل کوین کنید. قیمت فایل کوین در کوین‌نیک مارکت توسط خود شما تعیین می‌شود.",
        },
      },
      {
        "@type": "Question",
        name: "بهترین کیف پول فایل کوین کدام است؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: " برای فایل کوین ده‌ها کیف پول با نام‌های گوناگون وجود دارد و بنابراین اگر یک سرمایه‌گذار فایل کوین باشید، پیدا کردن کیف پول کار سختی برای شما نیست. کیف پول‌های سخت‌افزاری Ledger و Trezor. کیف پول‌های موبایل imToken، Exodus، Trust، Atomic، Coinomi، کیف پول تحت وب Lotus، Metamask از بهترین کیف پول‌های فایل کوین هستند.",
        },
      },
      {
        "@type": "Question",
        name: " آیا می‌توان فایل کوین را در کوین نیک مارکت نگهداری کرد؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "بله، در کوین‌نیک مارکت یک کیف پول اختصاصی و امن دارید، که می‌توانید رمزارزهیاتان را در آن نگهداری کنید. در این صورت دیگر هیچ نگرانی و استرسی بابت مسدود شدن موجودی‌تان در صرافی‌های خارجی به علت تحریم‌های مالی علیه ایران نخواهید داشت.",
        },
      },
      {
        "@type": "Question",
        name: "آیا فایل کوین ارزش سرمایه‌گذاری دارد؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: " ارائه دهندگان فضای ذخیره سازی ابری مانند آمازون و گوگل درآمد زیادی از این راه به دست می‌آورند. این موضوع نشان می‌دهد تقاضای نسبتا زیادی در این بازار وجود دارد. با فراگیر شدن ارزهای دیجیتال و پذیرش گسترده در جامعه، که این روزها نمود آن را بیش از پیش می‌بینیم، پروژه‌ای مانند فایل کوین می‌تواند هزینه فضای ذخیره‌سازی را به طرز چشمگیری کاهش دهد. به گفته مدیران فایل‌کوین، این پول همچنین می‌تواند به عنوان سرمایه شخصی و کسب و کارهای کوچک به اقتصاد باز گردد و تأثیر چشمگیری در زندگی مردم داشته باشد.",
        },
      },
    ],
  },
  faq: [
    {
      question: "How to buy Filecoin",
      answer: "Buy_Filecoin",
      id: "toggler1",
    },
    {
      question: "What is the best Filecoin wallet?",
      answer: "Filecoin_wallet_description",
      id: "toggler2",
    },
    {
      question: "Can I keep a Filecoin at coinnik Market?",
      answer: "Keep_Filecoin_description",
      id: "toggler3",
    },
    {
      question: "Is Filecoin worth the investment?",
      answer: "Filecoin_investment",
      id: "toggler4",
    },
  ],
  body: [
    [
      {
        heroTitle: "General information about Filecoin",
        subTitle: "What is Filecoin?",
        content: "Filecoin_description",
        btnTitle: "",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
      {
        heroTitle: "",
        subTitle: "History of Filecoin",
        content: "Filecoin_history_description",
        btnTitle: "Buy and sell Filecoin",
        btnLink: "",
        linkTitle: "Read more on the blog",
        Link: "",
      },
    ],
    [
      {
        heroTitle:
          "Buy and sell Filecoin without intermediaries in coinnik Market",
        subTitle: "Buy Filecoin",
        content: "Buy_Filecoin_description",
        btnTitle: "",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
      {
        heroTitle: "",
        subTitle: "Sell Filecoin",
        content: "Sell_Filecoin_description",
        btnTitle: "Buy and sell Filecoin",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
    ],
  ],
  posts: [
    [
      {
        heroTitle: "Technical analysis ; Candle patterns",
        content: "Technical_analysis",
        linkTitle: "Read more",
        time: "{{number}}Days ago",
      },
    ],
    [
      {
        heroTitle: "Technical analysis ; Candle patterns",
        content: "Technical_analysis",
        linkTitle: "Read more",
        time: "{{number}}Days ago",
      },
    ],
    [
      {
        heroTitle: "Technical analysis ; Candle patterns",
        content: "Technical_analysis",
        linkTitle: "Read more",
        time: "{{number}}Days ago",
      },
    ],
  ],
  blogTitle: "The latest Filecoin analysis on the blog",
  informationTitle: "Filecoin market statistics and information",
};

export default FilecoinCnt;
